import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TextField,Checkbox } from "@material-ui/core";
import {clone} from "ramda";
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    cstmAdj: {
        margin: "6px 0px",
    },
}));



export default function Address({initialValues, field, onChange, errors = {}, value }) {
    const classes = useStyles();
    const [copy, setCopy] = useState(false);
    //console.log("test",field.name.substr(0, field.name.indexOf("_")));
    const [editValues,setEditValues] = useState({
        primary_address_street:[
          {name:'primary_address_street', type:'varchar',label:'Address',value:value.primary_address_street},
          {name:'primary_address_state', type:'varchar',label:'State',value:value.primary_address_state},
          {name:'primary_address_postalcode', type:'varchar',label:'Postal Code',value:value.primary_address_postalcode},
          {name:'primary_address_country', type:'varchar',label:'Country',value:value.primary_address_country},
          {name:'primary_address_city', type:'varchar',label:'City',value:value.primary_address_city}
        ],
        alt_address_street:[
          {name:'alt_address_street', type:'varchar',label:'Address',value:value.alt_address_street},
          {name:'alt_address_state', type:'varchar',label:'State',value:value.alt_address_state},
          {name:'alt_address_postalcode', type:'varchar',label:'Postal Code',value:value.alt_address_postalcode},
          {name:'alt_address_country', type:'varchar',label:'Country',value:value.alt_address_country},
          {name:'alt_address_city', type:'varchar',label:'City',value:value.alt_address_city}
        ],
        billing_address_street:[
          {name:'billing_address_street', type:'varchar',label:'Address',value:value.billing_address_street},
          {name:'billing_address_state', type:'varchar',label:'State',value:value.billing_address_state},
          {name:'billing_address_postalcode', type:'varchar',label:'Postal Code',value:value.billing_address_postalcode},
          {name:'billing_address_country', type:'varchar',label:'Country',value:value.billing_address_country},
          {name:'billing_address_city', type:'varchar',label:'City',value:value.billing_address_city}
        ],
        shipping_address_street:[
          {name:'shipping_address_street', type:'varchar',label:'Address',value:value.shipping_address_street},
          {name:'shipping_address_state', type:'varchar',label:'State',value:value.shipping_address_state},
          {name:'shipping_address_postalcode', type:'varchar',label:'Postal Code',value:value.shipping_address_postalcode},
          {name:'shipping_address_country', type:'varchar',label:'Country',value:value.shipping_address_country},
          {name:'shipping_address_city', type:'varchar',label:'City',value:value.shipping_address_city}
        ]      
    });

    const [values, setValues] = useState({});

    const copyAddress = (check) => {        
        if(check)
        {
            setCopy(true);
            ///console.log("editValues copyAddress",initialValues);
            let newData = clone(editValues);    
            let newValues = {...values};        
            if(newData.primary_address_street)
            {
                newData.primary_address_street.map((field,key)=>{
                    newData.alt_address_street[key].value = initialValues[field.name];
                    let fieldname = field.name.replace("primary","alt");
                    newValues[fieldname] = initialValues[field.name];
                });
            }
            if(newData.billing_address_street)
            {
                newData.billing_address_street.map((field,key)=>{
                    newData.shipping_address_street[key].value = initialValues[field.name];
                    let fieldname = field.name.replace("billing","shipping");
                    newValues[fieldname] = initialValues[field.name];
                });
            }            
            setEditValues(newData);
            setValues(newValues);
            onChange(newValues);            
        }else{
            setCopy(false);
        }
    }
    const handleChange = (type,key,name,value) =>{
        let newValues = {...values,[name]:value};
        let newEditValues = clone(editValues);        
        newEditValues[type][key].value=value;       
        
        if(newEditValues.primary_address_street && copy)
        {
            // newEditValues.primary_address_street.map((field,key)=>{
            //     newEditValues.alt_address_street[key].value = initialValues && initialValues.primary_address_street[field.name];
            // });            
            let fieldname = name.replace("primary","alt");
            newValues[fieldname] = value;
        }
        if(newEditValues.billing_address_street && copy)
        {
            // newEditValues.billing_address_street.map((field,key)=>{
            //     newEditValues.shipping_address_street[key].value = initialValues.billing_address_street[field.name];
            // });            
            let fieldname = name.replace("billing","shipping");
            newValues[fieldname] = value;
        }
        setValues(newValues);
        
        onChange(newValues);
        setEditValues(newEditValues);
    }
    const onEditSetCopyFlag = ()=>{
        if(
            value && value.primary_address_street
            && value.primary_address_state
            && value.primary_address_postalcode
            && value.primary_address_country
            && value.primary_address_city
            && value.primary_address_street===value.alt_address_street
            && value.primary_address_state===value.alt_address_state
            && value.primary_address_postalcode===value.alt_address_postalcode
            && value.primary_address_country===value.alt_address_country
            && value.primary_address_city===value.alt_address_city){
            setCopy(true);
            copyAddress(true);
        }
        if(
            value && value.billing_address_street
            && value.billing_address_state
            && value.billing_address_postalcode
            && value.billing_address_country
            && value.billing_address_city
            && value.billing_address_street===value.shipping_address_street
            && value.billing_address_state===value.shipping_address_state
            && value.billing_address_postalcode===value.shipping_address_postalcode
            && value.billing_address_country===value.shipping_address_country
            && value.billing_address_city===value.shipping_address_city){
            setCopy(true);
            copyAddress(true);
        }
    }
    useEffect(()=>{
        onEditSetCopyFlag()
    },[values])


    
    return (
        <>
            <div style={{ marginBottom: "2px" }}>                
                {field.field_key === "primary_address_street" && "Primary Address"}
                {field.field_key === "alt_address_street" && "Other Address"}

                {field.field_key === "billing_address_street" && "Billing Address"}
                {field.field_key === "shipping_address_street" && "Shipping Address"}

            </div>
            <div className={classes.root}>
                {
                    editValues[field.field_key].map((addressField,key)=>(
                        <TextField
                            id={addressField.name}
                            name={addressField.name}
                            variant="outlined"
                            size="medium"
                            label={addressField.label}
                            required={field.required === 'true' ? true : false}                            
                            value={addressField.value}
                            classes={{ root: classes.cstmAdj }}
                            //placeholder={field.label}
                            //helperText={errors[field.name] ? errors[field.name] : null}
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(e)=>handleChange(field.field_key,key, e.target.name,e.target.value)}
                            disabled={copy && (field.field_key === "alt_address_street" || field.field_key === "shipping_address_street")}
                        />
                    ))
                }
            </div>
            {(field.field_key === "alt_address_street" || field.field_key === "shipping_address_street") &&
                <div>
                    <span>Copy from left</span>
                    <Checkbox
                        id={field.name}
                        name={field.name}
                        //error={iserror}
                        variant="outlined"
                        size={'medium'}
                        // value={value}
                        color="default"
                        checked={Boolean(copy)}
                        onChange={(e) => copyAddress(e.target.checked)}
                        helpertext={errors[field.name] ? errors[field.name] : null}
                    />
                </div>
            }
        </>
    );
};